import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Collapisble from '../../../../components/Collapsible';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './arts@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="arts">
    <h1>藝術</h1>
    <img src={image} alt="Arts at Kingston" />
    <p>
      藝術是一種強大的溝通渠道，讓學生能探索、建立自我及增加對身邊事物的認識。學生能透過不同的機會及方法來表達他們的想法，並與歷史、社會及文化層面連結起來。他們通過運用創新的方法、一系列的媒體及科技的使用，刺激他們的所思所想。學習藝術是讓孩子成長、提升創意、建立批判思維、學習解難技巧及提升社交能力的基礎。
    </p>
    <p>
      在京斯敦，學生能有充足的機會發展他們真正的興趣，他們能對自己的學業深思熟慮，成為一名懂得自我批判及自我反思的人。學生的自我反思及自我評估是十分重要的，使他們在學習上勇於嘗試。接觸及學習藝術開啟了他們對生命探索及學習的大門。製作及欣賞藝術的過程使學生感到愉悅，並能鼓勵他們不斷在生活中進行創作。
    </p>

    <Collapisble trigger="戲劇">
      <React.Fragment>
        <p>
          京斯敦的戲劇活動旨在讓學生透過身體及聲音來表達自我。在參與戲劇的過程中，學生能運用不同的臉部表情、肢體動作、身體律動與姿勢及聲音的技巧來傳達不同角色或故事所表達的情感內容。學生有充分的機會接觸不同的戲劇創作，包括創意運動、角色模仿、即興演奏、製作面具、小丑默劇、音樂劇、角色扮演、啞劇、木偶劇、案件重演、改編劇及小品。與此同時，學生也能
          從不同的時間、文化及地方來探索一系列的劇本及故事。他們也有機會到劇院表演，亦有機會向觀眾展示他們的創意作品及欣賞同儕的演出，從而成為一名具批判眼光的欣賞者。
        </p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="藝術、工藝及設計">
      <React.Fragment>
        <p>
          在京斯敦，學習設計被理解為“藝術、工藝及設計”。學生能有大量機會接觸視覺藝術、包括學習建築、陶藝創作、拼貼畫、服裝設計、繪畫、平面設計、攝錄影像、插圖、外觀設計、裝置藝術、首飾設計、園藝設計、面具製作、金屬品製作、油畫、紙藝術、舞台藝術、攝影、版畫製作、雕塑、背景設計、紡織及木製品創作。透過成為表演者、設計者、創作者及小導演，讓京斯敦的學生建立他們的自主能力及團體合作能力。
        </p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="音樂">
      <React.Fragment>
        <p>小學項目的音樂課程主要分為兩大學習方向：</p>
        <h4>創作音樂</h4>
        <p>學生運用想像力及音樂學習經驗來譜曲，並將之轉化為不同的形式，來表達特定的思想及情感。</p>
        <h4>對音樂的回應</h4>
        <p>
          學生有機會接觸不同的音樂形式、不同時段和不同文化的音樂。無論是個人或合作上，學生都有機會創作音樂及回應音樂。
        </p>
        <p>
          在京斯敦，學生有機會參與不同的音樂活動，包括唱歌、聽音樂、敲擊樂、即興表演、運用新、舊音符作曲、音樂表演、舞蹈、和音、分類和分析聲音及攝錄。
        </p>
        <p>聆聽技能的建立是所有學習層面中重要的一環，我們在音樂課上亦十分強調學生建立此技能。</p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="表演">
      <React.Fragment>
        <p>
          所有學生每年都會參與團體表演。學生會在低年級的時候參與排舞及唱歌。四至五年級的學生就會增加難度，他們會使用各種不同的敲擊樂器來進行表演。六年級的學生會表演和音、話劇及音樂劇舞蹈。
        </p>
        <p>本校亦為有興趣的高年級學生提供額外機會，分享他們的音樂技巧，讓他們可為其他老師及同學表演。</p>
      </React.Fragment>
    </Collapisble>
  </ContentLayout>
);
